export default __webpack_public_path__ + "static/media/PAKD.8c4614f8.png";